import {dateTime, duration} from "services/date";
import {OfferDistribution} from "../../../types/OfferDistribution";

export function deserializeOfferDistribution(offerDistribution: any): OfferDistribution {
  offerDistribution.started_at = dateTime(offerDistribution.started_at)
  offerDistribution.ended_at = dateTime(offerDistribution.ended_at)
  offerDistribution.duration = duration(offerDistribution.duration)
  offerDistribution.created_at = dateTime(offerDistribution.created_at)
  offerDistribution.updated_at = dateTime(offerDistribution.updated_at)

  return offerDistribution
}